module.exports = __webpack_public_path__ + "img/custom-web-app.c6159c4c.png";